import { FIELDS } from 'containers/Coso/CosoView/ChiTietCosoPanel/constants';
import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import {
  COSO_API,
  COSO_CHECK_FACILITYCODE_API,
  COSO_GETALL_API,
  COSO_EXPORT_API,
  COSO_EXPORT_WITH_IDS_API,
  COSO_GETALL_LOCATION_API,
} from './config';

export function getList(query) {
  return getFetch(`${COSO_API()}`, query);
}

export function getOne(_id) {
  return getFetch(`${COSO_API()}/${_id}`);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${COSO_API()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${COSO_API()}/${_id}`);
}

export function create(obj) {
  return postFetch(`${COSO_API()}`, obj);
}

export function checkFacilityCodeExist(obj) {
  return postFetch(`${COSO_CHECK_FACILITYCODE_API()}`, obj);
}

export function getSearchList(query, params = {}) {
  return getFetch(`${COSO_API()}`, {
    search: query,
    field: [
      'FacilityNameFull',
      'FrequencyOfMonitoring',
      'Address1',
      ...Object.values(FIELDS),
    ],
    page: 1,
    itemPerPage: 10,
    ...params,
  });
}

export function getAll() {
  return getFetch(`${COSO_GETALL_API()}`);
}

export function getLocation(query = {}) {
  return getFetch(`${COSO_GETALL_LOCATION_API()}`, query);
}

export function exportData(query) {
  return getFetch(`${COSO_EXPORT_API()}`, {
    ...query,
  });
}

export function exportDataWithIds(query) {
  return postFetch(`${COSO_EXPORT_WITH_IDS_API()}`, {
    ...query,
  });
}



// WEBPACK FOOTER //
// ./src/api/cosoApi.js